const buildImageRenderer = (content: string, mimeType: string, label: string) => {
  const cleaned = (content || '').replace(/\s+/g, '')
  const src = cleaned ? `data:${mimeType};base64,${cleaned}` : ''
  const fallback = cleaned ? '' : `No ${label} data available.`

  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      :root {
        color-scheme: light;
      }
      body {
        margin: 0;
        background: #ffffff;
        color: #64748b;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
      }
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        display: block;
      }
      .empty {
        font-size: 13px;
      }
    </style>
  </head>
  <body>
    ${src ? `<img src="${src}" alt="${label}" />` : `<div class="empty">${fallback}</div>`}
  </body>
</html>`
}

const pngRenderer = (content: string) => buildImageRenderer(content, 'image/png', 'PNG')

export const collectAssetReferences = () => []

export default pngRenderer
